module.exports = "\n.cabecalho{\n  background-color: #094D8F;\n  height: 60px;\n  min-width: 280px;\n}\n\n.logo{\n  margin-top: 10px;\n  width: 50px;\n}\n\n@media (min-width: 950px) {\n  .logo{\n    width: auto;\n  }\n\n  .logo{\n    margin-top: 15px;\n    width: 70px;\n  }\n\n  .cabecalho{\n    background-color: #094D8F;\n    height: 80px;\n    min-width: 280px;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cabecalho/cabecalho.component.css
// module id = ./src/app/cabecalho/cabecalho.component.css
// module chunks = main